module.exports = __webpack_public_path__ + "img/15@3x.933cd584.png";